import React, { Component } from "react";
import { DKLabel, DKButton, DKIcons,DKListPicker, showToast, TOAST_TYPE } from "deskera-ui-library";

import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import DataGridHolder from "../common/DataGridHolder";
import { COLUMN_CODE, TableManger, TABLES } from "../../managers/TableManger";
import { showFormPopup } from "../../components/menu/AddNewRecordPopup";
import ContactManager from "../../managers/ContactManager";
import AppManager from "../../managers/AppManager";
import { DealManager } from "../../managers/DealManager";
import Table from "../../services/table";
import JobPipelineService from "../common/Dashboard/JobPipeline";
import { commonCustomEvent, COMMON_EVENTS } from "../../services/event/commonEvents";
import { supportedFileTypes } from "../import_export/EximConstants";
import { getExportDataFile, getFileUrlForDownload } from "../../../src/components/import_export/utility/ExportData";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import ShowAddEmployeePopup from "./ShowAddEmployeePopup";
import { FILE_TYPE } from "../../constants/Constant";
import { isMobileWebView } from "../../utility/ViewportSizeUtils";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";



export default class Contacts extends Component {

  supportedFileTypes = {
    CSV: FILE_TYPE.CSV,
    XLSX: FILE_TYPE.XLSX
  };

  constructor(props) {
    super(props);
    this.state = {
      isPipelineStageAdded : false,
      selectedRows: [],
      showAddEmployee : false,
      actionRow : null
    };
    this.pipelineTableId = TableManger.getTableId(TABLES.JOB_PIPELINE);
    this.pipeLineData = [];
    this.stageTableId = TableManger.getTableId(TABLES.JOB_STAGE);
    this.stagesData = [];
    this.exportTypes = Object.keys(this.supportedFileTypes);
  }



  componentDidMount() {
    RouteManager.setPresenter(this);
    this.getPipeline();
  }

  componentWillUnmount() {
    commonCustomEvent.remove(COMMON_EVENTS.ADD_NEW_REC, () => { });
  }

  toggleExportPicker = (exporting = false) => {
    this.setState((prevState) => ({
      showExportPicker: !prevState.showExportPicker,
      exportInProgress: exporting,
    }));
  };

  getExportButtonTitle = () => {
    if (this.state.exportInProgress) {
      return `Exporting...`;
    } else {
      return `Export ${
        this.state.selectedRows?.length ? "Selected" : "Candidate"
      }`;
    }
  };

  onSelectExportType = (fileType) => {
    const queryParams = {
      format: fileType,
      timezoneOffset: new Date().getTimezoneOffset() * -1,
    };
    const filter = this.state.filter?.query ? {"logicalOperator":"and","conditions":this.state.filter.query} : {}
    const payload = { ids: this.state.selectedRows, filter: filter };

    const options = {
      endPointOptions: TableManger.getTableId(TABLES.CANDIDATE),
      fileName: "candidate",
      fileType: supportedFileTypes[fileType],
    };

    getFileUrlForDownload(queryParams, payload, options)
      .then((res) => {
        this.setState({ exportInProgress:false,selectedRows:[]  })
      })
      .catch((error) => {
        showToast(error, TOAST_TYPE.FAILURE);
      });

    this.toggleExportPicker(true);
  };

  onEmployeeToAdd = (data) => {
    let tenantData = TenantService.getData()
    let emailColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.EMAIL);
    let nameColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.NAME);
    let phoneColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.PHONE);

    let userData = {
      "firstName": data.rowData[nameColumnId],
      "lastName": "",
      "compensation": 0,
      "ctc": 0,
      "compensationCurrency": tenantData[TENANT.CURRENCY_CODE],
      "compensationPeriod": "30",
      "contact": "",
      "countryCode": tenantData[TENANT.COUNTRY_CODE],
      "emailId": data.rowData[emailColumnId],
      "makePayroll": true,
      "organizationName": tenantData[TENANT.ORGANIZATION_NAME],
      "name": data.rowData[nameColumnId]
    }

    this.setState((prevState) => ({
      showAddEmployee : true,
      employeeData : userData,
      actionRow : data.rowData
    }));

  }

  onViewContact = (data) => {
    if(PermissionUtils.hasAccess(MODULE.CANDIDATE,ACTION.VIEW)) {
      RouteManager.navigateToPage(`/candidate/${data.rowData.id}`)
    }

  }

  closeEmployeePopup = (isRefresh) => {
    this.setState((prevState) => ({
      showAddEmployee : false,
      refresh: isRefresh 
    }));
  }

  render() {
    return (
      <div className="parent-width">
      <div className="column parent-width flex-1">
        <div className="row">
          <div className="column bg-deskera-secondary p-r border-radius-m border-m parent-width banner-holder">
            <DKLabel text='<span style="font-size:20px">🙋‍♂️</span> Need help getting started? Learn more about managing candidate.' />

            <div className="row mt-r ml-l">
              <DKButton
                className="border-m bg-white"
                title="Read"
                onClick={AppManager.showComingSoonWarning}
              />
              <DKButton
                className="border-m ml-r bg-white"
                title="Watch"
                onClick={AppManager.showComingSoonWarning}
              />
            </div>
          </div>
          {(
            PermissionUtils.hasAccess(MODULE.CANDIDATE, ACTION.IMPORT) || 
            PermissionUtils.hasAccess(MODULE.CANDIDATE, ACTION.EXPORT)
          ) &&
            <div className="column bg-deskera-secondary p-r border-radius-m border-m parent-width ml-l banner-holder">
          <DKLabel text='<span style="font-size:20px">💼</span> Manage your Candidate.' />

            <div className="row mt-r ml-l">

              {PermissionUtils.hasAccess(MODULE.CANDIDATE, ACTION.IMPORT)&&<DKButton
                title="Import Candidate"
                // isReverse={true}
                icon={DKIcons.ic_import}
                className="border-m bg-white"
                onClick={() =>
                  RouteManager.navigateToPage(
                    PAGE_ROUTES.IMPORT_PORTAL,
                    `module=${TABLES.CANDIDATE}&origin=${PAGE_ROUTES.CANDIDATE}`
                  )
                }
              /> }
              <div className="row position-relative ml-r">
                {((!isMobileWebView()) && (PermissionUtils.hasAccess(MODULE.CANDIDATE, ACTION.EXPORT)) )&&<DKButton
                  title={this.getExportButtonTitle()}
                  icon={DKIcons.ic_export}
                  className="border-m bg-white"
                  onClick={() => {
                    this.toggleExportPicker(false);
                  }}
                />}
                {this.state.showExportPicker ? (
                  <DKListPicker
                    className="position-absolute border-m shadow-m z-index-3"
                    style={{ top: 30, left: 0, minWidth: 100 }}
                    data={this.exportTypes}
                    onSelect={(index) =>
                      this.onSelectExportType(this.exportTypes[index])
                    }
                    onClose={() => {
                      setTimeout(() => {
                        this.setState({ showExportPicker: false });
                      }, 10);
                    }}
                  />
                ) : null}
              </div>
            </div>
          </div>}
        </div>
        {this.state.isPipelineStageAdded && (
          <div className="column mt-l parent-width mb-s position-relative flex-1 margin-empty-mobile">
            <DataGridHolder
              tableName={TABLES.CANDIDATE}
              allowRowEdit={PermissionUtils.hasAccess(MODULE.CANDIDATE, [ACTION.EDIT])}
              allowColumnEdit={PermissionUtils.hasAccess(MODULE.CANDIDATE, [ACTION.EDIT])}
              allowRowAdd={true}
              allowColumnAdd={PermissionUtils.hasAccess(MODULE.CANDIDATE, [ACTION.EDIT])}
              allowColumnDelete={PermissionUtils.hasAccess(MODULE.CANDIDATE, [ACTION.DELETE])}
              allowColumnShift={PermissionUtils.hasAccess(MODULE.CANDIDATE, [ACTION.EDIT])}
              allowSearch={true}
              allowFilter={true}
              onEmployeeToAdd = {(data) => this.onEmployeeToAdd(data)}
              onRowSelect={(selectedRows) => {
                const selectedRowIds = selectedRows?.map((row) => row.id) || [];
                this.setState({ selectedRows: selectedRowIds });
              }}
              onRowDelete={(data) => { }}
              onRowEdit={(data) => {

                this.showPopup(data.rowData);
              }}
              onRowOpenClick={(data) => {
                if(PermissionUtils.hasAccess(MODULE.CANDIDATE,ACTION.VIEW)) {
                  RouteManager.navigateToPage(`/candidate/${data.rowData.id}`)
                }
              }}
              refresh={this.state.refresh}
              addButtonConfig={{
                title: "+ New Candidate",
                className: "bg-app text-white ml-s",
                onClick: () => this.showPopup(),
              }}
              allowDataExport={true}
              contextMenu={true}
              onViewContact = {(data) =>
                this.onViewContact(data)
              }
              moduleName = {"Candidate"}
              isSelectOptionShow={true}
              onFilter={(data)=>{
                this.setState({filter:data})
              }}
              module={MODULE.CANDIDATE}
            />
          </div>

                  )}
      </div>
        {this.state.showAddEmployee && (
          <div className="transparent-background">
            <ShowAddEmployeePopup
              employeeData={this.state.employeeData}
              onClose={(isRefresh) => this.closeEmployeePopup(isRefresh)}
              selectedRow = {this.state.actionRow}
            />
          </div>
        )}
      </div>
    );
  }
  showPopup = (row = {}) => {
    const selectedRow = Object.assign({}, row);
    // ContactManager.getDataToUpdate(selectedRow);
    showFormPopup(
      {
        tableName: TABLES.CANDIDATE,
        recordId: selectedRow.id,
        defaultValues: ContactManager.getDefaultValues(selectedRow),
        displayName: TABLES.CANDIDATE,
        inputData: this.pipeLineData,
        popupClass: 'custom-scroll'
      },
      () => {
        this.setState({ refresh: true });
      }
    );
  };
  getPipeline = () => {
    let req = null;
    let payload = null;
    Table.getRecords(this.pipelineTableId)
      .then((res) => {
        this.pipeLineData = JobPipelineService.getPipelineData(res);
        JobPipelineService.pipelineData = res;
        this.getStages();
      })
      .catch((err) => {
        this.setState({
          isPipelineStageAdded: true
        })
      });
  };
  getStages = () => {
    let req = null;
    let payload = null;
    Table.getRecords(this.stageTableId)
      .then((res) => {
        this.stagesData = JobPipelineService.getStageDataWithPipelineName(res, this.pipeLineData);
        JobPipelineService.stageData = res;
        this.setState({
          isPipelineStageAdded : true
        })
      })
      .catch((err) => {
        this.setState({
          isPipelineStageAdded: true
        })
      });
  }
}
